module.exports = __webpack_public_path__ + "static/media/teg_lock_logo.4d549b0b.png";